import React from "react";

const ManualPagination = ({ current, per, total, prev, next }) => {
    const last = Math.ceil(total / per);
    const from = (per * (current - 1)) + 1;
    const to = Math.min(from + per - 1, total);

    return (
        <div className='pagination'>
            <div className='total'>
                Página {current} de {last} <span className="pagination-details">
                    - Mostrando del{" "}
                    {from} al {to} de <strong>{total}</strong>
                </span>
            </div>
            {last > 1 && (
                <ul className='links'>
                    <li className='pagination__link prev'>
                       <button type="button" onClick={prev}>
                            Anterior
                        </button>
                    </li>
                    <li className='pagination__link next'>
                        <button type="button" onClick={next}>
                            Siguiente
                        </button>
                    </li>
                </ul>
            )}
        </div>
    );
};

export default ManualPagination;
